'use strict';

var isNode = typeof document === 'undefined';

var Classnames = require('classnames');
var React = require('react');
var ReactDOM = require('react-dom');
var SuperAgent = require('superagent');
var LinkedStateMixin = require('react-addons-linked-state-mixin');

var Constants = require('../constants');
var Global = require('../global');
var ParseAPI = Global.ParseAPI;
var ResponsiveMixin = Global.ResponsiveMixin;

var Breadcrumbs = require('./breadcrumbs.jsx');
var Thumbs = require('./thumb-grids.jsx');

if (!isNode) {
    // co-collection namespace
    require('./collection-listing.scss');
}

var CollectionHeader = React.createClass({
    mixins: [ ResponsiveMixin ],

    render: function() {
        var quickship = !this.props.category.seq;

        var introClasses = Classnames({
            'co-collection-intro': true,
            'co-collection-intro-with-thumb': !quickship,
        });
        const file = this.props.overrideIcon ? this.props.overrideIcon : this.props.category.urlkey;
        const icon = `${Constants.static}images/categories/icons/dark/${file}.png`;

        // catCat.body is inconsistent - make sure text block is a <p>
        var catIntro = this.props.category.body;
        if (catIntro.substr(0, 3) != '<p>') {
            catIntro = `<p>${catIntro}</p>`;
        }
        return (
            <div className='co-header co-blockheader'>
                <Breadcrumbs trail      = {this.props.breadcrumbs}
                             categories = {Payload.Collections}
                             route      = {this.props.route}
                             params     = {this.props.params} />
                
                <div className='co-collection-introblock'>
                    {this.state.viewportLayout == 'desktop' ?
                        <div className='co-collection-title'>
                            <div className='co-collection-title-content'>
                                {!quickship ?
                                    <img src={icon} alt={this.props.category.altTag || 'icon'} width={68} height={75.3}/>
                                : null}
                                {this.state.viewportLayout == 'desktop' ?
                                    <div>
                                        <h1>{this.props.category.title.toUpperCase()}</h1>
                                        <h2>{this.props.category.tagline.toUpperCase()}</h2>
                                    </div>
                                : null}
                            </div>
                        </div>
                    : null}
                    <div className={introClasses} dangerouslySetInnerHTML={{ __html: catIntro }} />
                </div>
            </div>
        );
    }
});

var CollectionListing = React.createClass({
    mixins: [ LinkedStateMixin ],

    // Given a URL including &page=n query string, return the respective category ID (catCat.id)
    _categoryIDForURL: function(url) {
        url = url.replace(/\&page=\d+$/, '');
        return this.props.route.collectionMap[url].id;
    },

    getInitialState: function() {
        return {
            breadcrumbs: Payload.breadcrumbs ? Payload.breadcrumbs : [],
            category: Payload.category ? Payload.category : null,
            items: Payload.items ? Payload.items : [],
            categoryID: this._categoryIDForURL(this.props.location.pathname),
        };
    },
    componentDidUpdate: function(prevProps, prevState) {
        // If changing to a new category (recommended react-router approach)
        if (prevProps.location && this.props.location) {
            var prevID = this._categoryIDForURL(prevProps.location.pathname);
            var nextID = this._categoryIDForURL(this.props.location.pathname);

            if (prevID != nextID) {
                this.setState({
                    categoryID: this._categoryIDForURL(this.props.location.pathname),
                    items: [],
                }, function() {
                    this.load();
                });
            }
        }
    },
    componentWillMount: function() {
        this.load();
    },
    load: function() {
        // As server: JSON is pre-loaded into Payload so don't execute remote fetches on server (otherwise it's http-within-http-within-http)
        // As client: no need to load by JSON for first page load (show the footer immediately though).
        if (isNode || (Payload.category && Payload.category.id == this.state.categoryID)) {
            this.setState(this.getInitialState());
            this.props.showFooter.requestChange(true);
            return;
        }
        this.props.showFooter.requestChange(false);
        var _this = this;
        var query = {
            command: 'collection',
            catID: this.state.categoryID
        };
        SuperAgent
            .get('/collections.json')
            .query(query)
            .end(function(err, res) {
                var r = ParseAPI(query, err, res);
                if (!r) {
                    return;
                }
                _this.setState({
                    breadcrumbs: r.breadcrumbs,
                    category: r.category,
                    items: r.items,
                });
                _this.props.showFooter.requestChange(true);
            });
    },
    render: function() {
        if (this.state.items.length == 0)
            return null;

        if (this.props.route.path.indexOf('office-chair') > -1) {
            var overrideIcon = 'office-chair';
        }

        return (
            <div>
                <CollectionHeader breadcrumbs  = {this.state.breadcrumbs}
                                  category     = {this.state.category}
                                  overrideIcon = {overrideIcon}
                                  route        = {this.props.route} />

                <Thumbs category     = {this.state.category}
                        thumbs       = {this.state.items}
                        type         = 'dynamic'
                        overrideIcon = {overrideIcon} />
            </div>
        );
    }
});

module.exports = CollectionListing;



// WEBPACK FOOTER //
// ./src/collections/collection-listing.jsx